var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-switch",class:( _obj = {'disabled': _vm.disabled}, _obj[("" + _vm.size)] = true, _obj )},[(_vm.hasLabelSlot)?_c('div',{staticClass:"the-switch__label",on:{"click":_vm.handleChange}},[_vm._t("default")],2):_vm._e(),_vm._v(" "),_c('a-switch',{attrs:{"checked":_vm.model,"disabled":_vm.disabled},on:{"change":_vm.handleChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }